import { CurriculumPricing } from '../../curriculum';
import { Brand, Subscription } from '../../curriculum/models/curriculumPricing';

export type CurriculumData = {
  ageGroup: string;
  brand: Brand;
  subscription: Subscription;
};

export const findCurriculumForItemNumber = (
  curriculum: CurriculumPricing[],
  itemNumber: string
): CurriculumData | undefined => {
  if (!itemNumber) return undefined;

  for (const c of curriculum) {
    for (const cr of c.curriculum) {
      const sub = cr.subscription.find(s => s.itemNumber === itemNumber);

      if (sub) {
        return { ageGroup: cr.name, brand: c.brand, subscription: sub };
      }
    }
  }
};
